<template>
  <a-collapse>

    <a-collapse-panel v-for="region in regions"
                      v-if="regions.length > 0"
                      :key="`region-${region.id}`"
                      :header="region.name">

      <region-helper-component slot="extra"
                               :region="region"
                               @deleted-region="deleteRegionFromList"/>

      <a-collapse>
        <a-collapse-panel v-for="nestedRegion in region.descendants.data"
                          v-if="regionHasDescendants(region)"
                          :key="`descendant-${nestedRegion.id}`"
                          :header="`Kantoren: ${nestedRegion.name}`"
                          class="no-padding">

          <region-helper-component slot="extra"
                                   :region="nestedRegion"
                                   @deleted-region="deleteRegionFromList"/>

          <offices-table :offices="nestedRegion.offices.data"
                         @deleted="deleteFromLists"/>

        </a-collapse-panel>

        <a-collapse-panel :header="`Kantoren: ${region.name}`" class="no-padding">

          <template slot="extra">
            <a-badge :count="countOffices(region, false)"
                     :number-style="{ backgroundColor: color.primary }"
                     :title="`Aantal kantoren onder regio: ${region.name}`"/>
          </template>

          <offices-table :offices="region.offices.data"
                         @deleted="deleteFromLists"/>

        </a-collapse-panel>

      </a-collapse>
    </a-collapse-panel>

    <a-collapse-panel header="Kantoren: zonder regio" class="no-padding">

      <template slot="extra">
        <a-badge :count="offices.length"
                 :number-style="{ backgroundColor: color.primary }"
                 title="Aantal kantoren zonder regio"/>
      </template>

      <offices-table :offices="offices"
                     @deleted="deleteFromLists"/>

    </a-collapse-panel>

  </a-collapse>
</template>

<script>
import RegionHelperComponent from "../../region/components/RegionHelperComponent";
import OfficesTable from "../../office/components/OfficesTable";
import regionsApi from "~/api/region";
import officeApi from "~/api/office";

export default {
  name: "OfficeRegionsPage",
  components: {RegionHelperComponent, OfficesTable},
  data() {
    return {
      color: {
        primary: '#1890ff',
      },
      regions: null,
      offices: null,
    };
  },
  mounted() {
    regionsApi.getRootRegions(['descendants', 'descendants.offices', 'offices'])
        .then(response => this.regions = response.data);
    officeApi.getWithoutRegions('owners')
        .then(response => this.offices = response.data);
  },
  methods: {
    countOffices(region, includeDescendants = true) {
      let count = 0,
          countDescendants = 0;

      if (region.offices.length) {
        count = region.offices.length;
      }

      if (includeDescendants === true && 'descendants' in region) {
        if (region.descendants.length) {
          region.descendants.forEach(descendant => {
            countDescendants += descendant.offices.length;
          })
        }
      }

      return count + countDescendants;
    },
    regionHasDescendants(region) {
      return (!!region.descendants && !!region.descendants.data);
    },
    deleteFromLists(officeId) {
      //Check office
      this.offices = this.offices.filter(x => x.id !== officeId);

      //Check regions
      this.regions.forEach(function (region) {
        region.offices = region.offices.filter(x => x.id !== officeId);

        //Check nested regions
        region.descendants.forEach(function (nestedRegion) {
          nestedRegion.offices = nestedRegion.offices.filter(x => x.id !== officeId);
        });
      });

      this.regions = [...this.regions]
    },
    deleteRegionFromList(regionId) {
      this.regions = this.regions.filter(x => x.id !== regionId);
    }
  }
};
</script>

<style>
.no-padding .ant-collapse-content-box {
  padding: 0;
}
</style>